/* November offer: placement, gift picker, and cart safety. Only loaded while the offer is on. */
(function () {
  var C = window.NOV_OFFER;
  if (!C) return;
  var KEY = 'nov_offer_color';
  var GIFT_PROP = '_nov_gift';
  var HANDLES = {};
  C.mugs.forEach(function (m) {
    HANDLES[m.h] = m;
    m.p = String(m.p).replace(/<[^>]+>/g, '');
    m.t = String(m.t).replace(/[\s–—-]+$/, '');
  });
  var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var realFetch = window.fetch.bind(window);
  var lastCart = null;
  var busy = false;

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function tpl(id) { var t = document.getElementById(id); return t ? t.content.cloneNode(true) : null; }
  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
  function getColor() { try { return localStorage.getItem(KEY); } catch (e) { return null; } }
  function setColor(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }
  function isCartPage() { return document.body.classList.contains('template-cart'); }

  /* ---------- Placement ---------- */
  function placeHero() {
    var f = tpl('nov-tpl-hero'), w = $('.homepage-wrapper');
    if (f && w) w.insertBefore(f, w.firstChild);
  }
  function placePromo() {
    var f = tpl('nov-tpl-promo');
    if (f) {
      var b = $('.product--add-to-cart-button');
      var w = b && (b.closest('.paymentButtonsWrapper') || b.parentElement);
      if (w) w.parentNode.insertBefore(f, w);
    }
    var d = tpl('nov-tpl-drift');
    if (d) { var q = $('.drift-pdp .qty-row'); if (q) q.parentNode.insertBefore(d, q); }
  }
  function placeBlog() {
    if (C.page !== 'article') return;
    var body = $('.article-content') || $('.rte') || $('article');
    $$('.rte,article,.article-content').forEach(function (e) { if (e.querySelectorAll('h2').length > (body ? body.querySelectorAll('h2').length : 0)) body = e; });
    if (!body) return;
    var hs = $$('h2', body);
    var card = tpl('nov-tpl-blog'), end = tpl('nov-tpl-end');
    if (card && hs.length > 1) hs[1].parentNode.insertBefore(card, hs[1]);
    if (end) body.appendChild(end);
  }
  function placeBar() {
    if (C.lang === 'en') return;
    var s = $('.announcement_block.active .announcement_text');
    if (s && C.tx.bar) s.innerHTML = C.tx.bar;
  }
  function badges() {
    $$('a[href*="/products/"]').forEach(function (a) {
      if (!a.querySelector('img') || a.dataset.novChecked) return;
      a.dataset.novChecked = '1';
      var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      if (!m || !HANDLES[m[1]]) return;
      if (a.closest('.global-drawer') || a.closest('.nov-page')) return;
      var host = a.closest('.grid-view-item-image') || a;
      if (host.querySelector('.nov-badge')) return;
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      var s = document.createElement('span');
      s.className = 'nov-badge';
      s.textContent = C.tx.badge;
      host.appendChild(s);
    });
  }

  /* ---------- Small motion ---------- */
  function spin() {
    var box = $('[data-nov-spin]');
    if (!box || still) return;
    var im = $$('img', box), i = im.indexOf($('img.on', box)), hold = false;
    box.addEventListener('mouseenter', function () { hold = true; });
    box.addEventListener('mouseleave', function () { hold = false; });
    setInterval(function () {
      if (hold) return;
      im[i].classList.remove('on');
      i = (i + 1) % im.length;
      im[i].classList.add('on');
    }, 2000);
  }
  function videos() {
    var vids = $$('.nov-vids video');
    if (!vids.length) return;
    var box = $('.nov-vids'), prev = $('.nov-prev'), next = $('.nov-next'), dots = $$('.nov-vdots i'), at = 0;
    vids.forEach(function (v) {
      v.addEventListener('click', function () { v.dataset.paused = v.paused ? '' : '1'; if (v.paused) v.play(); else v.pause(); });
      if (still) v.controls = true;
    });
    function near() { var r = box.getBoundingClientRect(), m = r.left + r.width / 2, best = 0, d = 1e9; vids.forEach(function (v, i) { var q = v.getBoundingClientRect(), x = Math.abs(q.left + q.width / 2 - m); if (x < d) { d = x; best = i; } }); return best; }
    function mark() { at = near(); dots.forEach(function (x, i) { x.classList.toggle('on', i === at); }); prev.hidden = at === 0; next.hidden = at === vids.length - 1; }
    function go(i) { var q = vids[i].getBoundingClientRect(), r = box.getBoundingClientRect(); box.scrollTo({ left: box.scrollLeft + q.left - r.left - (r.width - q.width) / 2, behavior: still ? 'auto' : 'smooth' }); }
    prev.addEventListener('click', function () { go(Math.max(0, at - 1)); });
    next.addEventListener('click', function () { go(Math.min(vids.length - 1, at + 1)); });
    box.addEventListener('scroll', mark, { passive: true });
    mark();
    if (still || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { if (!e.target.dataset.paused) { var p = e.target.play(); if (p && p.catch) p.catch(function () {}); } } else e.target.pause(); }); }, { threshold: 0.6 });
    vids.forEach(function (v) { io.observe(v); });
  }
  function landingPicker() {
    var btns = $$('.nov-co');
    if (!btns.length) return;
    function show(b) {
      btns.forEach(function (x) { x.setAttribute('aria-checked', x === b); });
      $('#novPickImg').src = b.dataset.big;
      $('#novPickImg').alt = 'Drift Mini in ' + b.dataset.name;
      $('#novPickName').textContent = b.dataset.name;
    }
    btns.forEach(function (b) { b.addEventListener('click', function () { setColor(b.dataset.id); show(b); }); });
    var saved = btns.filter(function (b) { return b.dataset.id === getColor(); })[0];
    if (saved) show(saved);
  }

  /* ---------- Cart ---------- */
  function chosen() {
    var id = getColor(), v = C.variants.filter(function (x) { return String(x.id) === id && x.a; })[0];
    return v || C.variants.filter(function (x) { return x.a; })[0];
  }
  function summarize(cart) {
    var s = { mugs: 0, gift: null, giftIndex: 0, drift: false };
    cart.items.forEach(function (it, i) {
      if (HANDLES[it.handle]) s.mugs += it.quantity;
      if (it.handle === C.drift) {
        s.drift = true;
        if (it.properties && it.properties[GIFT_PROP]) { s.gift = it; s.giftIndex = i + 1; }
      }
    });
    return s;
  }
  function html(s) {
    var n = Math.min(s.mugs, 2);
    var msg = s.mugs === 0 ? C.tx.c0 : s.mugs === 1 ? C.tx.c1 : s.drift ? C.tx.c3 : C.tx.c2;
    var out = '<div class="nov-prog"><div aria-live="polite">' + esc(msg) + '</div><div class="nov-bar"><i style="width:' + n * 50 + '%"></i></div></div>';
    if (s.mugs === 1) {
      var inCart = (lastCart.items || []).map(function (i) { return i.handle; });
      var picks = C.mugs.filter(function (m) { return m.a && inCart.indexOf(m.h) < 0; }).slice(0, 3);
      if (picks.length) out += '<div class="nov-rec"><b>' + esc(C.tx.second) + '</b>' + picks.map(function (m) { return '<div class="nov-rec-row"><img src="' + m.i + '" alt="" width="52" height="52"><div>' + esc(m.t) + '<br>' + esc(m.p) + '</div><button type="button" data-nov-add="' + m.v + '">' + esc(C.tx.add) + '</button></div>'; }).join('') + '</div>';
    }
    if (s.mugs >= 2 && !s.drift) {
      var c = chosen();
      if (c) out += '<div class="nov-gift"><div class="nov-gift-row"><img src="' + c.i + '" alt="" width="64" height="64"><div><b>' + esc(C.tx.tag) + '</b>' + esc(c.n) + ', ' + esc(C.tx.val) + '</div></div><div class="nov-sws" role="radiogroup" aria-label="Free gift color">' + C.variants.map(function (v) { return '<button type="button" class="nov-sw" role="radio" aria-label="' + esc(v.n) + '" title="' + esc(v.n) + '" aria-checked="' + (v.id === c.id) + '" data-nov-color="' + v.id + '"' + (v.a ? '' : ' disabled') + '><img src="' + v.i + '" alt=""></button>'; }).join('') + '</div><button type="button" class="nov-add-gift" data-nov-gift="' + c.id + '">' + esc(C.tx.addGift) + '</button></div>';
    }
    return out;
  }
  function targets() {
    var t = [];
    var d = $('cart-drawer .global-drawer__body--content');
    if (d) t.push(d);
    if (isCartPage()) {
      var f = $('form[action*="/cart"]:not([action*="/cart/add"])', $('.page-main--wrapper') || document);
      if (f && f.parentNode) t.push(f.parentNode);
    }
    return t;
  }
  function paint() {
    if (!lastCart) return;
    var content = html(summarize(lastCart));
    targets().forEach(function (p) {
      var box = p.querySelector(':scope > .nov-cart');
      if (!box) { box = document.createElement('div'); box.className = 'nov-cart'; p.insertBefore(box, p.firstChild); }
      if (box.dataset.c !== content) { box.innerHTML = content; box.dataset.c = content; }
    });
  }
  function bus() { return window.eventBus; }
  function afterMutation(json) {
    if (isCartPage()) { location.reload(); return; }
    if (bus() && json && json.sections && json.sections['cart-drawer']) bus().emit('update:cart:drawer', json);
    return sync();
  }
  function post(url, body) {
    body.sections = 'cart-drawer';
    return realFetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then(function (r) { return r.json(); });
  }
  function sync() {
    return realFetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      lastCart = cart;
      if (window.wetheme && window.wetheme.updateCartCount) window.wetheme.updateCartCount(cart);
      var s = summarize(cart);
      if (busy) { paint(); return; }
      /* A gift line must never stay without 2 mugs, or the customer would pay $29 for it. */
      if (s.gift && (s.mugs < 2 || s.gift.quantity > 1)) {
        busy = true;
        return post('/cart/change.js', { line: s.giftIndex, quantity: s.mugs < 2 ? 0 : 1 }).then(function (j) { busy = false; return afterMutation(j); }, function () { busy = false; });
      }
      paint();
    }).catch(function () {});
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-nov-color],[data-nov-gift],[data-nov-add]');
    if (!t) return;
    e.preventDefault();
    if (t.dataset.novColor) { setColor(t.dataset.novColor); paint(); return; }
    if (t.dataset.novGift) {
      t.disabled = true;
      var props = {}; props[GIFT_PROP] = '1';
      post('/cart/add.js', { items: [{ id: Number(t.dataset.novGift), quantity: 1, properties: props }] }).then(afterMutation, function () { t.disabled = false; });
      return;
    }
    if (t.dataset.novAdd) {
      t.disabled = true;
      post('/cart/add.js', { items: [{ id: Number(t.dataset.novAdd), quantity: 1 }] }).then(afterMutation, function () { t.disabled = false; });
    }
  });
  /* Follow every cart change the theme or an app makes. */
  var timer;
  function soon() { clearTimeout(timer); timer = setTimeout(sync, 250); }
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = realFetch.apply(window, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(soon, soon);
      /* The store shows only a small message after Add to cart. Open the drawer so the offer is seen. */
      if (/\/cart\/add/.test(url) && !isCartPage()) p.then(function (r) { if (r.ok && bus()) setTimeout(function () { bus().emit('open:cart:drawer', {}); }, 300); });
    }
    return p;
  };

  function init() {
    placeHero(); placePromo(); placeBlog(); placeBar();
    spin(); videos(); landingPicker(); badges();
    sync();
    var d = $('cart-drawer');
    if (d) new MutationObserver(function () { if (lastCart && !$('.global-drawer__body--content > .nov-cart', d)) paint(); }).observe(d, { childList: true, subtree: true });
    var bt;
    new MutationObserver(function () { clearTimeout(bt); bt = setTimeout(badges, 200); }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
